(function($) {

    var leftSlideEls = $('#solar2, #safety2, #business2, #business3');
    var rightSlideEls = $('#fiber2, #service2, #micro2');
    var $navProgress = $(".nav-progress-container");
    var $navProgressThumb = $(".nav-progress-bar");
    var $nav = $(".nav");
    var $copyWrap = $(".slide-copy-wrap");
    var $pageNum = $(".page-num");
    var $logo = $("#logo");
    var $logoContainer = $("#logo-container");
    var $burgerLabel = $("label[for='burger']");
    var $sectionHead = $(".section-header");
    var animating = false;

    //progress bar

    function navProgress() {
        var anchor = $('.active').attr('data-progress');
        var scrolled = (anchor / 25) * 100;
        var scrolledVar = scrolled + "%"
        $navProgressThumb.css("height", scrolledVar);
    };

    //reset animations

    function resetAnimation() {
        $copyWrap.scrollTop(0);
        leftSlideEls.removeClass('animate-left');
        rightSlideEls.removeClass('animate-right');
        $burgerLabel.removeClass('blue-nav');
        $navProgress.removeClass('blue-progress');
        $logo.removeClass('blue-svg');
    };

    //takes in business edge case where there is more than one animated section in a row
    function navigationColor() {

        if ($('.active').attr("id") == "business1" || $('.active').attr("id") == "business2" || $('.active').attr("id") == "business3") {
            $burgerLabel.removeClass('blue-nav');
            $navProgress.removeClass('blue-progress');
        } else {
            $burgerLabel.addClass('blue-nav');
            $navProgress.addClass('blue-progress');
        }
    };

    function blueLogo() {
        if ($('.active').attr("id") == "business1") {
            $logo.removeClass('blue-svg');
        } else if ($('.active').hasClass('right-horizontal')) {
            $logo.removeClass('blue-svg');
        } else if ($('.active').hasClass('left-horizontal')) {
            $logo.addClass('blue-svg');
        } else {
            $logo.addClass('blue-svg');
        }
        if ($('.active').hasClass('timeline')) {
            $logo.addClass('blue-svg');
        }
    };

    // stops elements from jumping when scrolling inside
    $('.horizontal-scroll-wrapper, .slide-copy-wrap').on('scroll touchmove mousewheel', function(e) {
        e.preventDefault();
    })

    // click var added to fix nav not working inside active onLeave sections
    $(document).on('click', function(e) {
        if (!click) {
            click = true;
        }
    })

    $("#fullpage").fullpage({
        anchors: [
            'home',
            'numbers',
            'video',
            'solar',
            'solar-two',
            'solar-three',
            'microgrids',
            'microgrids-two',
            'microgrids-three',
            'microgrids-four',
            'service',
            'service-two',
            'service-three',
            'community',
            'community-two',
            'community-three',
            'business',
            'business-two',
            'business-three',
            'fiber',
            'fiber-two',
            'safety',
            'safety-two',
            'safety-three',
            'contact'
        ],
        autoScrolling: true,
        scrollingSpeed: 700,
        fitToSection: true,
        css3: false,
        scrollOverflow: false,
        scrollHorizontally: true,
        scrollHorizontallyKey: "czMuYW1hem9uYXdzLmNvbV80VTljMk55YjJ4c1NHOXlhWHB2Ym5SaGJHeDVwNU8=",
        scrollOverflowReset: true,
        scrollOverflowResetKey: "czMuYW1hem9uYXdzLmNvbV9sUUNjMk55YjJ4c1QzWmxjbVpzYjNkU1pYTmxkQT09UzVy",
        licenseKey: "OPEN-SOURCE-GPLV3-LICENSE",

        onLeave: function(o, des, dir) {

            var scrollCheck = $('.section').eq(this.index).find('.slide-copy-wrap');
            var timelineCheck = $('.section').eq(this.index).find('.horizontal-scroll-wrapper');
            var mobileSection = $('.section').eq(this.index).find('.section-2');

            if (!click) {
                if (dir === 'up') {
                    if (scrollCheck.length > 0 && scrollCheck.scrollTop() !== 0) {
                        var scrollAmount = scrollCheck[0].scrollHeight - Math.ceil(scrollCheck.height());
                        var scrollVar = scrollAmount > 100
                            ? scrollCheck.scrollTop() - (scrollAmount * 0.25)
                            : 0;
                        scrollingCheck(scrollVar, scrollCheck, false);
                        return false;
                    }

                    if (timelineCheck.length > 0) {
                        var leftCheck = parseInt(timelineCheck.children('.horizon.scroll').css('left'));
                        if (leftCheck < 0) {
                            timelineScroll(timelineCheck, 'left');
                            return false;
                        }
                    }

                    if (mobileSection.length && mobileSection.height() > $(window).height()) {
                        var top = parseInt(mobileSection.css('top'));
                        var topSection = mobileSection.css('flex-direction') === 'row'
                            ? mobileSection.children('.left')
                            : mobileSection.children('.right');
                        var bottomSection = mobileSection.css('flex-direction') === 'row'
                            ? mobileSection.children('.right')
                            : mobileSection.children('.left');

                        if (top !== 0) {
                            var difference = Math.abs(top) - topSection.height();
                            var reducer = difference > topSection.height() || difference === 0
                                ? topSection.height()
                                : difference;
                            if (!animating) {
                                animating = true;
                                mobileSection.animate({
                                    top: top + reducer + 'px'
                                }, 750, function() {
                                    animating = false;
                                })
                            }
                            return false;
                        }
                    }
                } else {
                    if (scrollCheck.length > 0 && scrollCheck.scrollTop() < (scrollCheck[0].scrollHeight - Math.ceil(scrollCheck.height())) && $(window).width() > 737) {
                        var scrollAmount = scrollCheck[0].scrollHeight - Math.ceil(scrollCheck.height());
                        var scrollVar = scrollAmount > 100
                            ? scrollCheck.scrollTop() + (scrollAmount * 0.25)
                            : scrollAmount;
                        scrollingCheck(scrollVar, scrollCheck, true, scrollAmount);
                        return false;
                    }

                    if (timelineCheck.length > 0) {
                        var check = parseInt(timelineCheck.children('.horizon.scroll').css('left')) + parseInt(timelineCheck.children('.horizon.scroll').width());
                        if (check > $(window).width()) {
                            timelineScroll(timelineCheck, 'right');
                            return false;
                        }
                    }
                    if (mobileSection.length && mobileSection.height() > $(window).height() && $(window).width() <= 768) {
                        var top = parseInt(mobileSection.css('top'));
                        var topSection = mobileSection.css('flex-direction') === 'row'
                            ? mobileSection.children('.left')
                            : mobileSection.children('.right');
                        var bottomSection = mobileSection.css('flex-direction') === 'row'
                            ? mobileSection.children('.right')
                            : mobileSection.children('.left');

                        if (top === 0) {
                            if (!animating) {
                                animating = true;
                                mobileSection.animate({
                                    top: -topSection.height() + 'px'
                                }, 750, function() {
                                    animating = false;
                                })
                            }
                            return false;
                        } else if (Math.abs(top) < parseInt(bottomSection.height())) {
                            var difference = bottomSection.height() - Math.abs(top);
                            var reducer = difference > topSection.height()
                                ? topSection.height()
                                : difference;
                            if (!animating) {
                                animating = true;
                                mobileSection.animate({
                                    top: top - reducer + 'px'
                                }, 750, function() {
                                    animating = false;
                                })
                            }
                            return false;
                        }
                    }
                }
            }
        },

        afterLoad: function(origin, destination, direction) {
            //only show section progress if there is scrollable material
            if ($('.active').find('.slide-copy-wrap').length > 0) {
                var wrap = $('.active').find('.slide-copy-wrap')
                if (wrap[0].offsetHeight > wrap[0].scrollHeight) {
                    $('.active').find('.section-progress-bar').css('visibility', 'hidden');
                };
            };

            $('.slide-copy-wrap').siblings('.section-progress-bar').children('.bar').css('width', '0.1%'); // reset progress bars
            $('.horizontal-scroll-wrapper .horizon.scroll').css('left', '0'); // reset timeline
            $('.section-2').css('top', 0);

            if (click) {
                click = false;
            }
            if ($(window).width() < 769 && $(".active").hasClass('left-horizontal')) {
                $burgerLabel.addClass('blue-nav')
            } else if ($(window).width() < 769 && $(".active").hasClass('right-horizontal')) {
                $logo.addClass('blue-svg');
            };

            navProgress() //call function to track nav progress

            //call style-changing function on-load and reset when necessary
            if ($(".active").hasClass("left-horizontal")) {
                blueLogo()
                $copyWrap.scrollTop(0);
            } else if ($(".active").hasClass("right-horizontal")) {
                navigationColor();
            } else if ($(".active").hasClass("video")) {
                navigationColor();
                blueLogo();
            } else if ($(".active").hasClass("timeline")) {
                navigationColor();
                blueLogo();
            } else {
                resetAnimation();
            };
        }
    });


    function scrollingCheck(scrollVar, scrollCheck, add, scrollAmount) {
        if (!animating) {
            animating = true;
            if (scrollCheck.siblings('.section-progress-bar').length > 0) {
                var bar = scrollCheck.siblings('.section-progress-bar').children('.bar');
                var float = parseFloat(bar.width() / bar.parent().width() * 100);
                if (float < 101 && float > 0) {
                    var amount = scrollVar === scrollAmount
                        ? 100
                        : 25;
                    add
                        ? bar.css('width', float + amount + '%')
                        : bar.css('width', float - amount + '%');
                }
            }
            scrollCheck.stop().animate({
                scrollTop: scrollVar
            }, 500, function() {
                animating = false;
            })
        }
    }

    function timelineScroll(timeline, dir) {
        if ($(window).width() < 737) {
            var scroll = timeline.children('.scroll').children('.container').width();
        } else {
            var scroll = timeline.children('.scroll').children('.container').width()*2;
        }

        var left = timeline.children('.scroll').css('left');
        if (!animating) {
            var shift = dir === 'left'
                ? (parseInt(left) + scroll)
                : (parseInt(left) - scroll)
            animating = true;
            timeline.children('.scroll').stop().animate({
                'left': shift
            }, 1000, function() {
                animating = false;
            })
        }
    }

})(window.jQuery || {});

var $logoContainer = $("#logo-container");
var $downButton = $('.down-button')
var click = false;

///click events
$downButton.click(function() {
	click = true;
    fullpage_api.moveSectionDown();
})

$logoContainer.click(function() {
    fullpage_api.moveTo('home');
})

var $burgerLabel = $("label[for='burger']");
var $logo = $("#logo");

$(".nav-link").on('click', function(e) {
    e.preventDefault();
    $targetId = $(this).attr('href');
    fullpage_api.moveTo($targetId);
    fullpage_api.setAllowScrolling(true);
    if ($('#burger').is(":checked")) {
		$('#burger').prop('checked', false);
	}
});

$(".nav-item").each(function() {
    var url = $(this).attr("data-pre-img")
    new Image().src = url;
});

$burgerLabel.on('click', function() {
    if ($('#burger').is(":checked")) {
        fullpage_api.setAllowScrolling(true);
    } else {
        fullpage_api.setAllowScrolling(false);
    }
});

(function($) {

	$(window).on('load', setupTimeline);

	$(window).on('resize', function() {
		$('.horizon.scroll').css('left', 0);
		setupTimeline();
	})

	function setupTimeline() {
		var fullWidth = 0;
		var timeline = $('.horizontal-scroll-wrapper');
		var container = timeline.children('.scroll').children('.container');
		var width =  $(window).width() < 737 ? timeline.width() : timeline.width()*0.6;

		container.each(function() {
			$(this).width(width);
			fullWidth = fullWidth + width;
		});

		$('.horizon.scroll').width(fullWidth).css('display', 'flex');

		if ($(window).width() < 737) {
			var height = $($('.scroll .container .top')[0]).innerHeight();
			var images = $('.container.image');

			images.each(function() {
				$(this).height(height*2);
			})
		} else {
			var images = $('.container.image');

			images.each(function() {
				$(this).height('auto');
			})
		}
	}

})(window.jQuery || {});

